import debounce from 'lodash/debounce';
import { runSmartSubnav } from '../../snippets/smart-subnav/smart-subnav';
import { initControlProduct } from '../../snippets/product-base-control/product-base-control';
import { setMaxHeightStyle } from '../../scripts/utils/setMaxHeightStyle';
import YTPlayer from '../../scripts/components/YTPlayer';
import { initSmartHomeMobileSlider } from '../common/product-control-smart-home/product-control-smart-home';
import { initInstallationSlider } from '../../snippets/installation-slider/installation-slider';
import { initCollapsibleRows } from '../../snippets/collapsible-rows/collapsible-rows';

runSmartSubnav({
  intersectionThreshold: [0, 0.2],
  intersectionRatio: 0.2,
});

const initCollapsibleControlTechSpecsMenu = () => {
  const setMaxHeightToEls = () => {
    setMaxHeightStyle('[data-product-control-tech-specs-collapsible-content]');
  };

  window.addEventListener('load', setMaxHeightToEls);

  window.addEventListener('resize', debounce(setMaxHeightToEls, 50));
};

initControlProduct();
initSmartHomeMobileSlider();
initInstallationSlider();
YTPlayer.init();
initCollapsibleRows();
initCollapsibleControlTechSpecsMenu();
